// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"6b6a1feb","453":"4a91d8c7","796":"15163571"}[chunkId] + ".chunk.js";
};